import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, UserRound } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { useLang } from "../../i18n/LangContext";
import { LogoMark } from "./Primitives";

export const Header = () => {
  const { t, lang, toggle } = useLang();
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    document.body.classList.toggle("nav-open", open);
    return () => document.body.classList.remove("nav-open");
  }, [open]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("keydown", onKey);
    return () => { window.removeEventListener("scroll", onScroll); window.removeEventListener("keydown", onKey); };
  }, []);

  return (
    <header className={`site-header${scrolled ? " scrolled" : ""}`} data-testid="site-header">
      <div className="wrap nav">
        <a href="/#top" className="logo" data-testid="header-logo-link"><LogoMark /> IndusHub Afrique</a>
        <nav id="main-nav" className={`nav-links${open ? " open" : ""}`} aria-label="Navigation">
          {t.nav.links.map(([id, label]) => (
            <a key={id} href={`/#${id}`} onClick={() => setOpen(false)} data-testid={`nav-link-${id}`}>{label}</a>
          ))}
        </nav>
        <div className="nav-right">
          <button type="button" className="btn btn-ghost lang-btn" onClick={toggle} aria-label={t.nav.switchTo} data-testid="lang-toggle-btn">
            {lang === "fr" ? "EN" : "FR"}
          </button>
          <Link to={user?.role === "admin" ? "/admin" : "/espace"} className="btn btn-ghost account-btn" aria-label={user ? t.auth.mySpace : t.auth.signIn} data-testid="header-account-btn">
            <UserRound aria-hidden="true" /><span className="account-label">{user ? t.auth.mySpace : t.auth.signIn}</span>
          </Link>
          <a href="/#contact" className="btn btn-primary nav-cta" data-testid="header-cta-btn">{t.nav.cta}</a>
          <button
            type="button" className="nav-toggle" aria-label={t.nav.menu} aria-expanded={open} aria-controls="main-nav"
            onClick={() => setOpen((o) => !o)} data-testid="nav-menu-toggle"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
    </header>
  );
};
